import { Component, OnInit, Input } from '@angular/core';
import { DynamicContentSchemaFactory, DynamicContentSchemaFacade, SiteSettingModel } from '../../../services';
import { DefaultContents } from '../../../models/app-token';
import { Observable } from 'rxjs';

@Component({
  selector: 'dynamic-left-menu',
  templateUrl: './dynamic-left-menu.component.html',
  styleUrls: ['./dynamic-left-menu.component.css']
})
export class DynamicLeftMenuComponent implements OnInit {


  @Input()
  siteSetting: Observable<SiteSettingModel>;

  menuFacade: DynamicContentSchemaFacade;
  menuItemFacade: DynamicContentSchemaFacade;

  menuIdDefault: string;  // default-menu tree menu

  constructor(
    private readonly contentFacadeFactory: DynamicContentSchemaFactory) {
  }

  ngOnInit() {
    this.menuFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade('menu');
    this.menuFacade.getByCode(DefaultContents.DEFAULT_MENU_CODE).subscribe(m => {
      this.menuIdDefault = m.id;
    })
    this.menuItemFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade('menu-item');
  }
}
